import { FC } from "react";
import { Stack, Text } from "@fluentui/react";
import { Trans } from "react-i18next";
import AlertCircleIcon from "../../../../assets/Icons/svg/alertCircleIcon";
import { colorPallete } from "../../../../assets/color";

type Props = {
  fileName: string;
  // "exists": the project already has a document with this name.
  // "repeated": the name was picked more than once in this import.
  reason: "exists" | "repeated";
};

const styles = {
  container: {
    flexDirection: "row" as const,
    alignItems: "flex-start",
    gap: "8px",
    marginTop: "8px",
  },
  icon: { flexShrink: 0, lineHeight: 0 },
  title: {
    color: colorPallete.btRed,
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "24px",
  },
  hint: {
    color: colorPallete.grey,
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: "18px",
  },
};

const DuplicateNameError: FC<Props> = ({ fileName, reason }) => {
  return (
    <Stack style={styles.container} role="alert">
      <span style={styles.icon}>
        <AlertCircleIcon />
      </span>
      <Stack>
        <Text style={styles.title}>
          <Trans
            i18nKey={`document_name_${reason}_title`}
            values={{ fileName }}
            tOptions={{ interpolation: { escapeValue: false } }}
            components={{ strong: <strong style={{ fontWeight: 600 }} /> }}
          />
        </Text>
        <Text style={styles.hint}>
          <Trans
            i18nKey={`document_name_${reason}_hint`}
            components={{ strong: <strong style={{ color: colorPallete.black, fontWeight: 600 }} /> }}
          />
        </Text>
      </Stack>
    </Stack>
  );
};

export default DuplicateNameError;
